import React from "react";
import PropTypes from "prop-types";
import AsyncAutoComplete from "components/AsyncAutoComplete";
import loadCMBSOfferingTypesService from "services/cmbs/loadCMBSOfferingTypesService";

function SelectOfferingType({
  onSelect,
  disabled,
  error,
  placeholder,
  value,
  readOnly
}) {
  return (
    <AsyncAutoComplete
      promiseFn={loadCMBSOfferingTypesService}
      onSelect={onSelect}
      textPath="offering_desc"
      labelPath="offering_code"
      idPath="offering_code"
      disabled={disabled || readOnly}
      error={error}
      intent={!!error ? "danger" : null}
      placeholder={placeholder}
      value={value}
      readOnly={readOnly}
    />
  );
}

SelectOfferingType.propTypes = {
  value: PropTypes.string,
  onSelect: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  error: PropTypes.string,
  initialValue: PropTypes.object,
  placeholder: PropTypes.string
};

SelectOfferingType.defaultProps = {
  value: undefined,
  disabled: false,
  error: null,
  initialValue: {},
  placeholder: "Search..."
};

export default SelectOfferingType;
